{
  "saveHint": "Press {{shortcut}} to save",
  "leave": {
    "title": "Discard unsaved changes?",
    "body": "You have changes on this page that haven't been saved.",
    "confirm": "Discard changes",
    "cancel": "Keep editing"
  },
  "errors": {
    "ownRoles": "You can't change your own roles. Ask another administrator to do it.",
    "disableSelf": "You can't disable your own account.",
    "lastAdministrator": "At least one active user must keep full administrator access. Give another user full access first.",
    "useChangePassword": "To change your own password, use Change password in your account menu.",
    "systemRole": "System roles can't be renamed, deleted or given different access.",
    "grantFullAccess": "Only a user with every permission can give full administrator access.",
    "grantMissing": "You can only give access you have yourself. You don't have: {{list}}.",
    "userHasMoreAccess": "This user has access you don't have, so you can't change their account.",
    "scopeNotGrantable": "You can only give access to records you can reach yourself. Narrow the scope, or ask an administrator who reaches these records.",
    "adminScopeMustBeAll": "A role with every permission always reaches every record. Keep its scope as All.",
    "scopeUnitUnavailable": "One of the chosen org units is archived or no longer exists. Choose another unit.",
    "inviteDisabledUser": "Enable the user before sending an invitation.",
    "invitationNotOpen": "There's no open invitation to withdraw. It may have been accepted, withdrawn or replaced."
  },
  "users": {
    "title": "Users",
    "subtitle": "People who can sign in to this company, and what they can do.",
    "new": "New user",
    "newTitle": "New user",
    "newSubtitle": "The user signs in with this email and the initial password, then chooses their own.",
    "create": "Create user",
    "save": "Save user",
    "moreActions": "More actions",
    "changeOwnPassword": "Change your password",
    "searchLabel": "Search users",
    "searchPlaceholder": "Search name or email…",
    "clearSearch": "Clear search",
    "statusFilter": "Filter by status",
    "allStatuses": "All statuses",
    "roleFilter": "Filter by role",
    "allRoles": "All roles",
    "clearFilters": "Clear filters",
    "noRoles": "No roles",
    "neverSignedIn": "Never",
    "empty": {
      "title": "No users yet.",
      "filteredTitle": "No users match.",
      "filteredBody": "Try another name or email, or clear the filters."
    },
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "email": "Email",
      "phone": "Phone",
      "locale": "Language",
      "roles": "Roles",
      "status": "Status",
      "password": "Initial password",
      "lastLoginAt": "Last sign-in",
      "createdAt": "Created",
      "updatedAt": "Last changed"
    },
    "status": {
      "ACTIVE": "Active",
      "DISABLED": "Disabled",
      "LOCKED": "Locked",
      "PASSWORD_PENDING": "Password change pending"
    },
    "sections": {
      "account": "Account",
      "access": "Access",
      "password": "Initial password",
      "activity": "Sign-in activity",
      "signIn": "How they get in"
    },
    "hints": {
      "email": "Used to sign in. It must not belong to another user.",
      "locale": "The language the app opens in for this user.",
      "access": "Roles decide which screens and actions the user has.",
      "ownRoles": "You can't change your own roles. Ask another administrator.",
      "rolesUnavailable": "Roles couldn't be loaded, so they can't be changed here.",
      "ownStatus": "You can't disable your own account.",
      "status": "A disabled user can't sign in and is signed out everywhere.",
      "initialPassword": "Hand this password to the user. They must change it the first time they sign in.",
      "passwordLength": "At least 10 characters."
    },
    "rolesPlaceholder": "Choose roles",
    "rolesSearch": "Search roles…",
    "rolesEmpty": "No roles found.",
    "rolesClear": "Clear selection",
    "rolesSelected": "{{n}} roles",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "generatePassword": "Generate a password",
    "lockedTitle": "This account is locked",
    "lockedBody": "Too many failed sign-in attempts. It unlocks by itself after a few minutes, or you can unlock it now.",
    "selfNotice": "This is your own account. You can change your details here; roles and status must be changed by another administrator.",
    "errors": {
      "emailTaken": "This email address is already used by another user.",
      "notCreated": "The user wasn't created",
      "notSaved": "The user wasn't saved"
    },
    "conflict": {
      "title": "Someone else changed this user",
      "body": "Your changes weren't saved. Reload to see the latest version, then make your changes again.",
      "reload": "Reload latest"
    },
    "toast": {
      "created": "{{name}} can now sign in",
      "createdBody": "They'll be asked to choose their own password.",
      "updated": "User saved",
      "invited": "{{name}} is added",
      "invitedBody": "An invitation e-mail to {{email}} is queued. Whether it was sent shows on their page.",
      "inviteFailed": "{{name}} was added, but the invitation wasn't sent",
      "scopeNotEnforced": "Scope doesn't narrow records yet",
      "scopeNotEnforcedBody": "For now scopes narrow purchases, projects and sales documents only. Every record stays within reach for: {{roles}}. The scope still counts as restricted when changing the org chart and when granting or managing users."
    },
    "reset": {
      "action": "Reset password",
      "title": "Reset the password of {{name}}?",
      "body": "They are signed out everywhere and must choose a new password when they next sign in with this one.",
      "password": "Temporary password",
      "confirm": "Reset password",
      "done": "Password reset for {{name}}",
      "doneBody": "Give them the temporary password; they'll choose their own at sign-in."
    },
    "unlock": {
      "action": "Unlock account",
      "title": "Unlock {{name}}?",
      "body": "They can try to sign in again straight away.",
      "done": "{{name}} unlocked"
    },
    "scope": {
      "title": "Records each role reaches",
      "hint": "Narrow a role to an org unit and the units under it, to records assigned to the user, or to their own records. For now scopes narrow purchases, projects and sales documents only: other permissions still reach every record.",
      "kindFor": "Records {{role}} reaches",
      "unitsFor": "Org units for {{role}}",
      "kinds": {
        "ALL": "All",
        "ORG_SUBTREE": "Org subtree",
        "ASSIGNED": "Assigned only",
        "OWN": "Own only"
      },
      "explain": {
        "ALL": "Every record.",
        "ORG_SUBTREE": "Purchases, projects and sales documents of the chosen units and the units under them.",
        "ASSIGNED": "Only purchases and projects the user is assigned to or takes part in; no sales documents.",
        "OWN": "Only purchases, projects and sales documents the user created, and projects they manage."
      },
      "adminAll": "Full administrator access always reaches every record.",
      "notEnforced": "None of this role's permissions is narrowed by scopes yet, so it still reaches every record. The scope still counts as restricted when changing the org chart and when granting or managing users.",
      "unitsPlaceholder": "Choose org units",
      "unitsSearch": "Search org units…",
      "unitsEmpty": "No org unit found",
      "unitsClear": "Clear units",
      "unitsSelected": "{{n}} units",
      "unitRequired": "Choose at least one org unit.",
      "archivedUnit": "{{name}} (archived)"
    },
    "access": {
      "title": "Data access",
      "hint": "Which records the user's roles reach.",
      "everything": "Has full administrator access: every permission, on every record.",
      "noRoles": "No roles, so no access to any records.",
      "rolesLabel": "Roles and the records they reach",
      "subtreeOf": "{{units}} and the units under them",
      "nothing": "No records",
      "moduleOff": "Module off",
      "moduleOffHint": "Its module is turned off. The scope is kept and applies again when the module is back.",
      "byPermission_one": "Permission by permission ({{count}})",
      "byPermission_other": "Permission by permission ({{count}})",
      "permissionsLabel": "Records reached per permission",
      "permission": "Permission",
      "reaches": "Reaches",
      "unavailable": "Data access couldn't be loaded.",
      "notNarrowed": "Not narrowed by scopes",
      "notApplied": "Doesn't narrow records yet",
      "notAppliedHint": "For now scopes narrow purchases, projects and sales documents only. None of this role's permissions is narrowed, so it still reaches every record. The scope still counts as restricted when changing the org chart and when granting or managing users.",
      "invite": {
        "label": "E-mail an invitation",
        "body": "They get a link to choose their own password. The link works for 3 days.",
        "unavailable": "Not available: e-mail isn't set up for this company, so the invitation couldn't be sent.",
        "setUp": "Set up e-mail to invite people by e-mail.",
        "askAdmin": "Ask an administrator to set up e-mail to invite people by e-mail.",
        "openSettings": "Open e-mail settings"
      },
      "password": {
        "label": "Set a password now",
        "body": "You hand the password over. They change it the first time they sign in."
      }
    },
    "invite": {
      "action": "Send invitation e-mail",
      "title": "Send {{name}} an invitation?",
      "body": "An e-mail goes to {{email}} with a link to choose a new password. Any earlier link stops working, and the current password stops working once they set the new one.",
      "confirm": "Send invitation",
      "done": "Invitation queued for {{email}}"
    },
    "invitation": {
      "title": "Invitation",
      "loading": "Loading the invitation…",
      "loadFailed": "The invitation couldn't be loaded.",
      "reload": "Refresh",
      "sentTo": "To",
      "addressRemoved": "address removed",
      "recipientRemoved": "the recipient's details were removed",
      "state": {
        "PENDING": "Queued",
        "SENT": "Sent",
        "FAILED": "Not sent",
        "EXPIRED": "Expired",
        "ACCEPTED": "Accepted",
        "REVOKED": "Withdrawn"
      },
      "detail": {
        "PENDING": "The e-mail is on its way. Delivery can take a few minutes.",
        "SENT": "The e-mail was sent. The link works until {{date}}.",
        "FAILED": "The e-mail couldn't be sent: {{reason}}. The link never reached them.",
        "EXPIRED": "The link expired on {{date}} before it was used.",
        "ACCEPTED": "They set their own password on {{date}}.",
        "REVOKED": "Withdrawn on {{date}}. The link doesn't work any more."
      },
      "fixThenResend": "Fix what stopped it, then send the invitation again.",
      "stillQueued": "Still queued. Delivery can take longer; check again later.",
      "resend": "Send again",
      "revoke": "Withdraw invitation",
      "revokeTitle": "Withdraw the invitation?",
      "revokeBody": "The link stops working straight away. You can send a new invitation later.",
      "revoked": "Invitation withdrawn"
    }
  },
  "roles": {
    "title": "Roles",
    "subtitle": "Sets of permissions you give to users.",
    "new": "New role",
    "newTitle": "New role",
    "newSubtitle": "Name the role and choose what its users can do.",
    "save": "Save role",
    "moreActions": "More actions",
    "empty": "No roles yet.",
    "fullAccess": "Full access",
    "system": "System",
    "fields": {
      "name": "Name",
      "nameAr": "Name in Arabic",
      "description": "Description",
      "descriptionAr": "Description in Arabic",
      "access": "Access",
      "users": "Users"
    },
    "permissionCount": "{{chosen}} of {{total}} permissions",
    "accessSummary": "{{chosen}} of {{total}} permissions chosen.",
    "groupCount": "{{chosen}} of {{total}}",
    "selectAllIn": "Select all in {{group}}",
    "lockedPermission": "You can only give permissions you have yourself.",
    "moduleOff": "Turned off for your company; these permissions take effect when it is turned back on.",
    "usersCount_one": "{{n}} user",
    "usersCount_other": "{{n}} users",
    "showUsers": "Show users with {{name}}",
    "sections": {
      "details": "Details",
      "access": "Access"
    },
    "hints": {
      "systemName": "System roles keep their name.",
      "grantable": "Permissions you don't have yourself are locked."
    },
    "systemNotice": "This is a system role: its name and access are fixed. You can change the Arabic name and the description.",
    "systemDescription": "Built-in role with every permission. It cannot be deleted.",
    "fullAccessTitle": "Full access",
    "fullAccessBody": "This role has every permission, including ones added in future versions.",
    "errors": {
      "nameTaken": "A role with this name already exists.",
      "notSaved": "The role wasn't saved"
    },
    "conflict": {
      "title": "Someone else changed this role",
      "body": "Your changes weren't saved. Reload to see the latest version, then make your changes again.",
      "reload": "Reload latest"
    },
    "toast": {
      "created": "Role created",
      "updated": "Role saved",
      "deleted": "Role deleted"
    },
    "delete": {
      "action": "Delete role",
      "title": "Delete {{name}}?",
      "body": "The role is removed permanently. No users have it.",
      "confirm": "Delete role",
      "inUseTitle": "{{name}} is in use",
      "inUseBody_one": "{{n}} user has this role. Remove it from them before deleting it.",
      "inUseBody_other": "{{n}} users have this role. Remove it from them before deleting it.",
      "close": "Close",
      "showUsers": "Show users"
    },
    "prerequisites": {
      "title_one": "One permission won’t work on its own",
      "title_other": "{{count}} permissions won’t work on their own",
      "item": "{{permission}} needs {{missing}}",
      "and": ", ",
      "or": " or ",
      "add_one": "Add the missing permission",
      "add_other": "Add the {{count}} missing permissions",
      "stamp": "Gaps",
      "listHint": "Some of its permissions need others it does not have. Open the role to fill the gaps."
    }
  }
}
